import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Lock, CreditCard, ArrowRight, Star } from 'lucide-react';
export function PricingOptions() {
  return <section id="pricing" className="py-12 md:py-20 lg:py-24 bg-clinical-deep text-white relative overflow-hidden" data-id="element-262">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none" data-id="element-263">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, #ffffff 1.5px, transparent 1.5px)',
        backgroundSize: '32px 32px'
      }} data-id="element-264" />
      </div>
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-clinical-mid/10 rounded-full blur-[120px] pointer-events-none" data-id="element-265"></div>

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14" data-id="element-267">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-accent mb-4" data-id="element-268">
            Tu inversión
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4 leading-[1.05] uppercase" data-id="element-269">
            Elegí tu{' '}
            <span className="accent-italic-gold normal-case" data-id="element-270">Mega Pack</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-base md:text-lg text-white/70" data-id="element-271">
            Dos formas de entrar al sistema.{' '}
            <span className="accent-italic-gold" data-id="element-272">Una sola decisión.</span>
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-5xl mx-auto items-stretch" data-id="element-273">
          {/* CARD 1 — Plan Inicial (Gold-themed) */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative bg-[#0A1F38] rounded-3xl p-6 md:p-8 border border-clinical-accent/30 flex flex-col h-full mt-4 md:mt-6" data-id="element-274">
            {/* Badge */}
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-clinical-accent text-clinical-deep text-[10px] font-bold uppercase tracking-[0.22em] py-1.5 px-4 rounded-full whitespace-nowrap flex items-center gap-1.5" data-id="element-275">
              <Star size={11} className="fill-clinical-deep" strokeWidth={0} data-id="element-276" />
              Plan Inicial
            </div>

            <div className="mt-2" data-id="element-277">
              <h4 className="text-xl md:text-2xl font-black text-white mb-2 uppercase leading-tight" data-id="element-278">
                <span className="mr-1.5" data-id="element-279">📘</span>Mega Pack Enfermería
              </h4>
              <p className="text-clinical-accent/80 text-sm md:text-base mb-5 md:mb-6 font-medium" data-id="element-280">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-5 md:mb-7" data-id="element-281">
              <div className="text-clinical-accent/40 line-through text-base font-medium mb-1" data-id="element-282">
                $51.000
              </div>
              <div className="flex items-baseline gap-2" data-id="element-283">
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-284">
                  $19.990
                </span>
                <span className="text-sm md:text-base font-semibold text-white/50" data-id="element-285">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-7 md:mb-8 flex-grow" data-id="element-286">
              {['Acceso a los 6 Tomos completos', 'Los 6 Bonos de regalo', 'Actualizaciones de por vida'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-287">
                  <div className="w-6 h-6 rounded-full border border-clinical-accent/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-288">
                    <Check className="w-3.5 h-3.5 text-clinical-accent" strokeWidth={3} data-id="element-289" />
                  </div>
                  <span className="text-white/90 text-sm md:text-base" data-id="element-290">
                    {item}
                  </span>
                </li>)}
            </ul>

            <button className="w-full py-4 rounded-full border border-clinical-accent/40 text-clinical-accent font-bold text-sm md:text-base hover:bg-clinical-accent/10 transition-colors mt-auto uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-291">
              <ArrowRight size={16} data-id="element-292" />
              Quiero mi Mega Pack
            </button>
          </motion.div>

          {/* CARD 2 — Plan Avanzado (Green-themed, highlighted) */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative bg-[#0A1F38] rounded-3xl p-6 md:p-8 border-2 border-emerald-400 shadow-[0_20px_50px_rgba(16,185,129,0.15)] flex flex-col h-full mt-4 md:mt-6" data-id="element-293">
            {/* Badge */}
            <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-emerald-400 text-clinical-deep text-[10px] font-bold uppercase tracking-[0.22em] py-1.5 px-4 rounded-full whitespace-nowrap flex items-center gap-1.5" data-id="element-294">
              <Star size={11} className="fill-clinical-deep" strokeWidth={0} data-id="element-295" />
              Más elegido
            </div>

            <div className="mt-2" data-id="element-296">
              <h4 className="text-xl md:text-2xl font-black text-white mb-2 uppercase leading-tight" data-id="element-297">
                <span className="mr-1.5" data-id="element-298">🏆</span>Mega Pack + Avanzado
              </h4>
              <p className="text-emerald-300/90 text-sm md:text-base mb-5 md:mb-6 font-medium" data-id="element-299">
                6 Tomos + 6 Bonos + 30 casos clínicos resueltos
              </p>
            </div>

            <div className="mb-5 md:mb-7" data-id="element-300">
              <div className="text-emerald-300/40 line-through text-base font-medium mb-1" data-id="element-301">
                $69.000
              </div>
              <div className="flex items-baseline gap-2" data-id="element-302">
                <span className="text-4xl md:text-5xl font-black text-white" data-id="element-303">
                  $27.990
                </span>
                <span className="text-sm md:text-base font-semibold text-white/50" data-id="element-304">
                  ARS
                </span>
              </div>
            </div>

            <ul className="space-y-4 mb-7 md:mb-8 flex-grow" data-id="element-305">
              {[{
              text: 'Incluye todo lo del Mega Pack básico',
              highlight: false
            }, {
              text: '30 casos clínicos resueltos paso a paso',
              highlight: true
            }, {
              text: 'Casos organizados por área y complejidad',
              highlight: false
            }, {
              text: 'Ideal para prácticas, exámenes e internado',
              highlight: false
            }].map((item, idx) => <li key={idx} className={`flex items-start gap-3 ${item.highlight ? '-mx-2 px-2 py-2 rounded-xl bg-emerald-400/10 border border-emerald-400/30' : ''}`} data-id="element-306">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${item.highlight ? 'bg-emerald-400' : 'border border-emerald-400/40'}`} data-id="element-307">
                    <Check className={`w-3.5 h-3.5 ${item.highlight ? 'text-clinical-deep' : 'text-emerald-400'}`} strokeWidth={3} data-id="element-308" />
                  </div>
                  <span className={`text-sm md:text-base ${item.highlight ? 'font-bold text-white' : 'text-white/90'}`} data-id="element-309">
                    {item.text}
                  </span>
                </li>)}
            </ul>

            <button className="w-full py-4 rounded-full bg-emerald-400 text-clinical-deep font-bold text-sm md:text-base hover:bg-emerald-300 transition-colors mt-auto uppercase tracking-wider flex items-center justify-center gap-2 shadow-[0_8px_24px_rgba(16,185,129,0.3)]" data-id="element-310">
              <ArrowRight size={16} data-id="element-311" />
              Quiero el Pack + Avanzado
            </button>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-8 md:mt-12 flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-white/60 max-w-3xl mx-auto text-center" data-id="element-312">
          <div className="flex items-center gap-1.5" data-id="element-313">
            <ShieldCheck size={14} className="text-white/50" data-id="element-314" />
            <span data-id="element-315">Garantía 7 días</span>
          </div>
          <span className="text-white/20" data-id="element-316">·</span>
          <div className="flex items-center gap-1.5" data-id="element-317">
            <Lock size={14} className="text-white/50" data-id="element-318" />
            <span data-id="element-319">Pago seguro</span>
          </div>
          <span className="text-white/20" data-id="element-320">·</span>
          <div className="flex items-center gap-1.5" data-id="element-321">
            <CreditCard size={14} className="text-white/50" data-id="element-322" />
            <span data-id="element-323">Mercado Pago · Tarjeta · Transferencia</span>
          </div>
        </motion.div>
      </div>
    </section>;
}